import { MouseEvent, MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";
import "./Button.scss";

export type buttonVariants =
  | "primary"
  | "disabled"
  | "secondary"
  | "secondary--outline"
  | "primary--outline"
  | "text"
  | "tertiary"
  | "white-border"
  | "blue-text"
  | "text-orange"
  | "light-blue"
  | "icon"
  | "text-orange--border";

type ButtonProps = {
  className?: string;
  label: string;
  type?: "button" | "submit" | "reset" | undefined;
  to?: string;
  variant?: buttonVariants;

  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
  size?: "lg" | "md";
  style?: any;
  state?: any;
  children?: ReactNode;
};

const Button = (props: ButtonProps) => {
  const {
    label,
    type,
    to,
    variant = "disabled",
    disabled,
    size,
    state,
    className,
    children,
  } = props;

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
  };

  const BTN_BG = disabled ? "disabled" : variant;
  if (to) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a onClick={handleClick}>
        <Link
          to={to}
          state={state}
          {...props}
          type={type}
          className={`button button-${size} button-${BTN_BG} ${className}`}
        >
          {label}
          {children}
        </Link>
      </a>
    );
  }

  return (
    <button
      {...props}
      type={type}
      className={`button button-${size} button-${BTN_BG} ${className}`}
    >
      {label.toUpperCase()}
      {children}
    </button>
  );
};

export default Button;
